import { useEffect, useRef } from 'react'

export const ADSENSE_CLIENT = 'ca-pub-5419766553705803'
export const ADSENSE_SIDEBAR_SLOT = '3278550247'

declare global {
  interface Window {
    adsbygoogle?: unknown[]
  }
}

function loadAdSense() {
  if (document.querySelector('script[data-tigg-ads]')) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`
  script.crossOrigin = 'anonymous'
  script.dataset.tiggAds = ''
  document.head.appendChild(script)
}

export default function GoogleAd({
  slot,
  className = '',
}: {
  slot: string
  className?: string
}) {
  const insRef = useRef<HTMLModElement>(null)

  useEffect(() => {
    loadAdSense()
    const el = insRef.current
    if (!el || el.getAttribute('data-adsbygoogle-status')) return
    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch {
      // AdSense rejects duplicate fills during remounts
    }
  }, [slot])

  return (
    <ins
      ref={insRef}
      className={`adsbygoogle ${className}`.trim()}
      style={{ display: 'block' }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  )
}
